import React from 'react';
import Button from '../components/ui/Button';

const Wellness = () => {
  return (
    // Increased top padding from pt-24 to pt-36
    <div className="page-transition pt-36 pb-20">
      <div className="container mx-auto px-6">
        <div className="relative rounded-2xl overflow-hidden mb-16 h-[50vh]">
          <img src="https://images.unsplash.com/photo-1540555700478-4be289fbecef?q=80&w=2000&auto=format&fit=crop" alt="Spa" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
            <h1 className="text-white text-5xl md:text-7xl font-serif">Spa & Wellness</h1>
          </div>
        </div>
        
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl mb-6">Unwind and Restore</h2>
          <p className="text-lg text-brand-600 mb-10 leading-relaxed">
            There is a spa or wellness center available at Amani Palms by Manolo Beach Resort. 
            Immerse yourself in tranquility and let our treatments rejuvenate your body and mind amidst the tropical breeze.
          </p>
          <Button to="/contact" variant="primary">Ask About Treatments / Opening Times</Button>
        </div>
      </div>
    </div>
  );
};

export default Wellness;